import { apiFetch } from './api';

export const fetchSummaries = async (caseId: string) => {
    try {
        const response = await apiFetch(`/conversation/${caseId}/summaries`);

        if (!response.ok) {
          throw new Error('Failed to fetch results');
        }

        return await response.json();

      } catch (error) {
        console.error('Error fetching results:', error);
        return null;
      }
};
